import React, { useState } from "react";
import {
  NftDetailMiddleSection
} from "./style";
import WalletsModal from "../../components/New/WalletsModal";
import RadarChartComponent from "../CollectionDetails/RadarGraph";

const NftDetailMidSection: React.FC<{ collectionId: any, name: any, score:any, networkId: number }> = ({
  collectionId, name, networkId, score
}: any) => {
  const [walletModalOpen, setWalletModalOpen] = useState<boolean>(false);

  const handleToggleModal = () => {
    setWalletModalOpen((prev) => !prev);
  };

  return (
    <>
      <NftDetailMiddleSection>
            <div style={{ width: "100%", display: "block" }}>
              <RadarChartComponent id={collectionId} name={name} networkId={networkId} score={score}/>
            </div>
      </NftDetailMiddleSection>

      <WalletsModal open={walletModalOpen} handleClose={handleToggleModal} />
    </>
  );
};

export default NftDetailMidSection;
